<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FMEP">If nothing but the bright side of characters should be shown, we should sit down in despondency, and think it utterly impossible to imitate them in <span class="ePub-I">anything</span>.</p>
<p class="FMEPC">—S<span class="ePub-SC">AMUEL</span> J<span class="ePub-SC">OHNSON</span>, on the writing of biography</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?30309927